/**
 * locationService.js — thin compatibility shim.
 * All real logic is in locationManager.js.
 * Legacy callers that import getLocation / getCurrentLocationFromIP continue to work.
 */
export {
  getActiveLocation as getLocation,
  DEFAULT_LOCATION,
  toForecastApiString,
} from './locationManager';

/** @deprecated No longer used — IP lookup removed for privacy. */
export const getCurrentLocationFromIP = async () => {
  console.warn('[locationService] getCurrentLocationFromIP is deprecated. Use activateCurrentLocation from locationManager instead.');
  return null;
};
